import { IntegrationChannelType } from 'generated/graphql';

export const isValidUpdateOutboundIntegrationInput = (
  channelType: IntegrationChannelType,
) => {
  switch (channelType) {
    case IntegrationChannelType.Slack:
    case IntegrationChannelType.Email:
      return true;
    default:
      return false;
  }
};
